export function useAppShellLayoutReturn({ chat, handlers, secondaryNavProps, projectDialog }) {
  return {
    activePrimaryKey: chat.activePrimaryKey,
    handlePrimaryNavChange: handlers.handlePrimaryNavChange,
    handleAccountMenuAction: chat.handleAccountMenuAction,
    secondaryNavProps,
    projectDialog,
    mainLayoutProps: chat.mainLayoutProps,
    threadShareThread: chat.threadShareThread,
    pinLimitDialogOpen: chat.pinLimitDialogOpen,
    closePinLimitDialog: chat.closePinLimitDialog,
  }
}
